import type * as ents from '@attain-apps/entities'

/** Lookup map of warning messages keyed by {@link ents.extra.space.Warning.Code} */
export type WarningLookup = Partial<
  Record<ents.extra.space.Warning.Code, string>
>

/**
 * {@link https://ngrx.io/docs State} of this feature
 */
export interface State {
  error?: Error
  lookup?: WarningLookup
  isLoading: boolean
}

export namespace State {
  export const INITIAL: Readonly<State> = {
    error: undefined,
    isLoading: false,
    lookup: undefined,
  }
}
